const types = require('constants/actionTypes');

const opened = ({ query = '' }) => (dispatch, getState) => dispatch({
    type: types.GLOSSARY_OPENED,
    payload: {
        query,
        originCountry: getState().profile.get('originCountry')
    },
});

module.exports = opened;
